import { AxiosError } from 'axios';
import HomeConstants from '../../../../pages/home/constants';
import WelcomeConstants from '../../../../pages/welcome/constants';

const errorInterceptor = (error: AxiosError) => {
    if (error.response?.status === 401) {
        sessionStorage.clear();
        window.location.href = WelcomeConstants.default;
    } else if (error.response?.status === 403) {
        window.location.href = HomeConstants.PATH;
    }

    return Promise.reject(error);
};

export default errorInterceptor;
